import { forwardRef, useMemo } from 'react';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { postfixTestId } from '../../util/testId';
import { TokenDesign } from './TokenDesign';
import bundle from './NovaComponents-Token-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
const normalizeThreshold = showMoreThreshold => {
  // only 5-100 are valid threshold values
  return (
    // If the specified threshold is 1 to 5, set it to 5
    showMoreThreshold > 0 && showMoreThreshold < 5 ? 5 :
    // For other invalid values, set it to 100
    showMoreThreshold > 100 || showMoreThreshold <= 0 ? 100 : showMoreThreshold
  );
};
export const GroupToken = /*#__PURE__*/forwardRef((props, ref) => {
  const localize = useTextLocalizer();
  const groupTokenValues = props.values;
  const tokenCount = groupTokenValues.length;
  const showMoreThreshold = normalizeThreshold(props.showMoreThreshold ?? 100);
  const showMoreItem = props.onMorePress && tokenCount > showMoreThreshold;
  const menuItems = useMemo(() => groupTokenValues.slice(0, showMoreThreshold).map(value => {
    return {
      testId: postfixTestId(props.testId, value),
      text: value,
      closable: !props.readOnly,
      closeIconAriaLabel: localize('menuButton.menuItem.closeIcon.default.aria'),
      closeIconTooltip: localize('menuButton.menuItem.closeIcon.default.tooltip.label'),
      closableAriaText: localize('menuButton.menuItem.delete.aria')
    };
  }), [groupTokenValues, showMoreThreshold, props.testId, props.readOnly, localize]);
  const labelCount = props.customLabelCount ?? tokenCount;
  return /*#__PURE__*/_jsx(TokenDesign, {
    index: props.index,
    className: props.className,
    style: props.style,
    disabled: props.disabled,
    testId: props.testId,
    variant: props.variant,
    readOnly: props.readOnly,
    tabIndex: props.tabIndex,
    onClose: props.onClose,
    onFocus: props.onFocus,
    ref: ref,
    value: props.label,
    labelCount: labelCount,
    ariaLabel: props.ariaLabel,
    ariaDescribedBy: props.ariaDescribedBy,
    onClick: props.onClick,
    includeDropdown: true,
    menuSections: showMoreItem ? [{
      items: [{
        testId: postfixTestId(props.testId, '-moreMenuItem'),
        text: localize('groupToken.menuItem.moreMenuItem.label'),
        closable: false
      }]
    }, {
      items: menuItems
    }] : [{
      title: tokenCount > showMoreThreshold ? localize('groupToken.menuItem.moreMenuHeading.label', {
        count: showMoreThreshold.toString()
      }) : undefined,
      items: menuItems
    }],
    onItemSelected: ([itemLocation]) => {
      const [sectionIndex, itemIndex] = itemLocation;
      if (showMoreItem && sectionIndex === 0 && itemIndex === 0) {
        props.onMorePress?.();
      }
    },
    onCloseItem: props.onCloseItem,
    closeButtonProps: props.closeButtonProps,
    preventScrollOnFocus: props.preventScrollOnFocus
  });
});
//# sourceMappingURL=GroupToken.js.map